import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Warning(props: IconProps): JSX.Element {
  return <Warning.Outline {...props} />;
}

/**
 * TODO: moved from NextJS but not appearing in core, needs to be fixed
 */
Warning.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M4.0112 20.9156H19.989C20.2485 20.9155 20.5036 20.8482 20.7292 20.7201C20.9549 20.5919 21.1435 20.4075 21.2766 20.1847C21.4096 19.9619 21.4826 19.7084 21.4884 19.4489C21.4941 19.1895 21.4325 18.933 21.3095 18.7045L13.321 3.86856C12.7543 2.81669 11.2459 2.81669 10.6792 3.86856L2.69073 18.7045C2.56771 18.933 2.50607 19.1895 2.51184 19.4489C2.51761 19.7084 2.59059 19.9619 2.72364 20.1847C2.8567 20.4075 3.04528 20.5919 3.27096 20.7201C3.49664 20.8482 3.75169 20.9155 4.0112 20.9156V20.9156Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7309 9.15816L12 14.8769L12.2686 9.1605C12.2703 9.12396 12.2644 9.08746 12.2515 9.05324C12.2386 9.01902 12.2188 8.98779 12.1934 8.96146C12.168 8.93514 12.1375 8.91427 12.1038 8.90014C12.07 8.886 12.0338 8.8789 11.9972 8.87925V8.87925C11.9612 8.8796 11.9257 8.88715 11.8928 8.90145C11.8598 8.91575 11.83 8.93652 11.8052 8.96251C11.7804 8.98851 11.761 9.01922 11.7483 9.05282C11.7355 9.08642 11.7296 9.12224 11.7309 9.15816V9.15816Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 18.6196C11.8145 18.6196 11.6333 18.5646 11.4791 18.4616C11.3249 18.3586 11.2048 18.2122 11.1338 18.0409C11.0629 17.8696 11.0443 17.6811 11.0805 17.4992C11.1166 17.3174 11.2059 17.1503 11.337 17.0192C11.4681 16.8881 11.6352 16.7988 11.8171 16.7626C11.9989 16.7265 12.1874 16.745 12.3587 16.816C12.53 16.887 12.6764 17.0071 12.7795 17.1613C12.8825 17.3155 12.9375 17.4967 12.9375 17.6821C12.9375 17.9308 12.8387 18.1692 12.6629 18.345C12.487 18.5209 12.2486 18.6196 12 18.6196Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
